<template>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="height: 100%;" >
    <div class="card h-100 pb-3 pt-3">
      <div class="card-header">
        <div class="form-group">
          <label class="ml-2" style="font-size: 14px;margin-right: 10px">
            Notifications:
          </label>
          <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : isNotifications, 'bootstrap-switch-off bootstrap-switch-focused' : !isNotifications }">
            <div class="bootstrap-switch-container" @click="updateIsNotificationsForUser()">
              <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
              <span class="bootstrap-switch-label"></span>
              <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
            </div>
          </div>
          <span class="ml-2 text-primary cursor-pointer" v-if="muteNotiFlag" v-on:click="toggleMute(false)"><i class="fa fa-bell"></i></span>
          <span class="ml-2 text-primary cursor-pointer" v-else v-on:click="toggleMute(true)"><i class="fa fa-bell-slash"></i></span>
        </div>
        <div class="row">
          <div class=" col-md-9">
            <div class="buttons">
              <button class="btn btn-primary btn-sm mr-3" :disabled="opBtnLoading || isStopStatusCake" @click="syncStatusCake">
                <div class="loader mini_loader" v-if="opBtnLoading"></div>
                <span v-else>Sync Status Cake, Racks and Nodes</span>
              </button>
              <button v-if="!isStopStatusCake" class="btn btn-danger btn-sm" :disabled="opBtnLoading" @click="stopStatusCake(true)">
                <div class="loader mini_loader" v-if="opBtnLoading"></div>
                <span v-else>Turn Off</span>
              </button>
              <button v-else class="btn btn-primary btn-sm" :disabled="opBtnLoading" @click="stopStatusCake(false)">
                <div class="loader mini_loader" v-if="opBtnLoading"></div>
                <span v-else>Turn On</span>
              </button>
            </div>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a @click="chnageTab(0)" class="nav-link active" id="up-tab" data-toggle="tab" href="#up" role="tab" aria-controls="up">Current Outages</a>
              </li>
              <li class="nav-item">
                <a @click="chnageTab(1)" class="nav-link" id="down-tab" data-toggle="tab" href="#down" role="tab" aria-controls="down">Recent Outage</a>
              </li>
              <li class="nav-item">
                <a @click="chnageTab(2)" class="nav-link" id="settings-tab" data-toggle="tab" href="#test-tab" role="tab" aria-controls="test-tab">Test Settings</a>
              </li>
              <li class="nav-item">
                <a @click="chnageTab(3)" class="nav-link" id="racks-tab" data-toggle="tab" href="#racks" role="tab" aria-controls="racks">Racks</a>
              </li>
              <li class="nav-item">
                <a @click="chnageTab(4)" class="nav-link" id="nodes-tab" data-toggle="tab" href="#nodes" role="tab" aria-controls="nodes">Nodes</a>
              </li>
            </ul>
          </div>
<!--          <div v-if="this.currentOpenTab!==3">-->
            <div v-if="this.currentOpenTab !== 2 && this.currentOpenTab!==3 &&  this.currentOpenTab!==4" class="col-md-3 text-right">
              <input @input="searchOutages" v-model="gloablSearchQuery" type="text" class="form-control m-t-40" :placeholder="(currentOpenTab === 0) ? 'Search in current outages' : 'Search in recent outages'" />
            </div>
<!--          <div v-if="this.currentOpenTab !== 2 && this.currentOpenTab!==3 &&  this.currentOpenTab!==4" class="col-md-1 text-right">-->
<!--            <button v-if="this.currentOpenTab!==3 && this.currentOpenTab!==4  " class="btn btn-primary  m-t-40" data-toggle="modal" data-target="#outageMacrosModal">Preset Replies</button>-->
<!--          </div>-->
            <div v-else class="col-md-3 align-bottom">
              <button v-if="this.currentOpenTab!==3 && this.currentOpenTab!==4  " class="btn btn-primary btn-block" @click="addNewSetting"> <i class="fa fa-plus"></i> Add New Setting</button>
            </div>
<!--          </div>-->

        </div>
      </div>
      <div class="card-body pb-0">
        <div class="tab-content customer-table">
          <div id="up" class="tab-pane fade active show">
            <outages-table :presetMacros="presetMacros" ref="downTable" datatableId="datatableRecentOutage" status="Down"/>
          </div>
          <div id="down" class="tab-pane fade">
            <outages-table :presetMacros="presetMacros" ref="upTable" datatableId="datatableOutage" status="Up"/>
          </div>
          <div id="racks" class="tab-pane fade">
            <racks ref="allRacks"/>
          </div>
          <div id="nodes"  class="tab-pane fade">
            <nodes ref="allNodes"/>
          </div>
          <div id="test-tab" class="tab-pane fade">
            <div v-for="(selectedSetting, index) in selectedStatusSettings.settings" class="row mb-3">
              <div class="col-md-4">
                <label>Choose Status</label>
                <select v-model="selectedSetting.status" class="form-control">
                  <option v-for="status in testStatusList" :value="status">{{ status }}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>Select Setting</label>
                <select v-model="selectedSetting.setting" class="form-control">
                  <option v-for="setting in statusSettings" :value="setting">{{ setting }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <section v-if="selectedSetting.setting === 'expiry'">
                  <label>Number Of Hours</label>
                  <input v-model="selectedSetting.value" type="number" class="form-control" placeholder="Hours..."/>
                </section>
              </div>
              <div v-if="index > 0" class="col-md-1 align-bottom">
                <button class="btn btn-danger btn-sm" @click="removeSetting(index)"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-primary pull-right" @click="saveSettings">Save Changes</button>
                <br>
                <small class="pull-left">Last Updated By <b>{{ selectedStatusSettings.meta.updatedBy }}</b> at <b>{{ selectedStatusSettings.meta.updatedAt | formatDate }}</b></small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_body">
      <div class="modal" tabindex="-1" role="dialog" id="viewEventsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Test ID: <code>{{selectedItemForView.testId}}</code>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Test Name:
                <code>{{selectedItemForView.name }}</code>
              </h6>
              <br>
              <h6>
                Previous Events
                <code v-if="selectedItemForView.status === 'Up'" class="pull-right">Total Downtime: {{totalDownDurationOfSelectedItem}}</code>
              </h6>
              <code>
                <table class="table eventsTable">
                  <thead>
                  <tr>
                    <th class="text-center">Start</th>
                    <th class="text-center">End</th>
                    <th class="text-center">Time Duration</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Status Code</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(event, index) in selectedItemForView.events" :key="'event_' + index">
                    <td class="text-center">{{event.start | formatDate}}</td>
                    <td class="text-center" v-if="event.end !== undefined">{{event.end | formatDate}}</td>
                    <td class="text-center" v-else>Current</td>
                    <td class="text-center" v-if="event.end !== undefined">{{timeDifferenceBetweenGivenDates(event.end, event.start)}}</td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">{{event.status}}</td>
                    <td class="text-center">{{event.statusCode}}</td>
                  </tr>
                  </tbody>
                </table>
              </code>
              <section v-if="selectedItemForView.notes !== undefined">
                <h6>Test & Notes History</h6>
                <code>
                  <table class="table notesTable">
                    <thead>
                    <tr>
                      <th class="text-center">Detail</th>
                      <th class="text-center">Added On</th>
                      <th class="text-center">Added By</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(note, index) in selectedItemForView.notes" :key="'note_' + index">
                      <td>{{note.note}}</td>
                      <td class="text-center">{{note.noteDate | formatDate}}</td>
                      <td class="text-center">{{note.noteAddedBy ? note.noteAddedBy : ''}}</td>
                    </tr>
                    </tbody>
                  </table>
                </code>
              </section>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addTicketModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">ADD TICKET URL</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Ticket URL</label>
                <textarea class="form-control" v-model="selectedItemForView.ticket_url"></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="addTicket()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'addTicket'"></div>
               Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addNoteModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Test Name: {{selectedItemForView.name}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Add A Note To This Test</label>
                <textarea class="form-control" v-model="selectedItemForView.note"></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="addNote()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'addNote'"></div>
                Add Note
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="changeLiveStatusModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Test Name: {{selectedItemForView.name}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="liveStatusDropDown">Update Live Status</label>
                <select style="padding-top: 5px;padding-bottom: 5px" class="form-control" v-model="selectedItemForView.status" id="liveStatusDropDown">
                  <option value="Up">Up</option>
                  <option value="Down">Down</option>
                </select>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="updateLiveStatus()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'updateLiveStatus'"></div>
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
      <nodes-modal ref="nodes"/>
      <racks-modal ref="racks"/>
      <preset-outages-modal :presetMacros="presetMacros" />
      <ticket-modal ref="ticketModal"/>

    </div>
  </div>

</template>

<script>
import {db} from "@/firebase/init";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import swal from "sweetalert2";
import {find, map} from "lodash";
import refreshToken from "../../../mixins/refreshTokenMixin";
import dateMixin from '../../../mixins/dateMixin';
import OutagesTable from "../../../components/Admin/Dashboard/OutagesTable";
import racks from "../../../components/Admin/Dashboard/racks";
import nodes from "../../../components/Admin/Dashboard/nodes";

momentDurationFormatSetup(moment);
export default {
  name: "index",
  mixins: [refreshToken, dateMixin],
  data() {
    return {
      accounts: [],
      testsOff: [],
      presetMacros: [],
      testsOn: [],
      loading: false,
      opBtnLoading: false,
      insAx: null,
      initTables: false,
      selectedItemForView: {},
      action: null,
      totalDownDurationOfSelectedItem: '',
      upListener: null,
      downListener: null,
      pauseListener: null,
      currentOpenTab: 0,
      gloablSearchQuery: '',
      statusSettings: ['expiry'],
      testStatusList: [
        'Moved',
        'Suspended',
        'Domain Expired',
        'Other'
      ],
      selectedStatusSettings: {
        meta: {},
        settings:[
          {
            status: '',
            setting: '',
            value: ''
          }
        ]
      }
    };
  },
  components:{
    OutagesTable,
    racks,
    nodes,
    nodesModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/nodesModal"),
    racksModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/racksModal"),
    presetOutagesModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/presetOutagesModal"
            ),
    ticketModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Tasks/outageTicketModal")
  },
  computed: {
    _(){
      return _;
    },
    user() {
      return this.$store.getters.user;
    },
    userToken() {
      return this.$store.getters.getUserToken;
    },
    isNotifications() {
      return this.$store.getters.isNotifications;
    },
    muteNotiFlag() {
      return this.$store.getters.muteNotiFlag;
    },
    isStopStatusCake() {
      return this.$store.getters.getStatusCakeStatus;
    }
  },

  beforeDestroy(){
    this.destroyListeners();
  },
  methods: {
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_outages")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies || [];

      }
    },
    addTicket() {
        this.action = 'addTicket';
        console.log('Adding ticket in: ' + this.selectedItemForView.testId);
        db.collection('status_cake_tests').doc(this.selectedItemForView.testId.toString())
            .update(this.selectedItemForView)
            .then(()=>{
              /* eslint-disable */
              $("#addTicketModal").modal("hide");
              /* eslint-enable */
              swal('Success', 'Ticket has been successfully added', 'success');
            }).catch(() => {
          swal('Error', 'Error in adding ticket url!', 'error');
        }).finally(() => {
          this.selectedItemForView = {};
          this.action = null
        });
    },
    saveSettings () {
      this.selectedStatusSettings.meta = {
        updatedBy: this.user.firstName + ' ' + this.user.lastName,
        updatedAt: new Date().toISOString()
      };
      db.collection('permissions').doc('monitor-settings').set(this.selectedStatusSettings).then(() => {
        swal('Success!', 'Settings has been saved', 'success');
      })
      this.addLog({
        primaryPlan: 'Account Based Operation',
        message: 'StatusCake setting has been saved.',
        level: "info"
      })
    },
    removeSetting (index) {
      this.selectedStatusSettings.settings.splice(index, 1);
    },
    addNewSetting(){
      this.selectedStatusSettings.settings.push({
        status: '',
        setting: '',
        value: ''
      })
    },
    async stopStatusCake (stop) {
      this.opBtnLoading = true;
      const useRef = await db.collection('users').doc(this.user.uid).get();
      const userData = useRef.data();
      userData.stopStatusCake = stop;
      await db.collection('users').doc(this.user.uid).update(userData);
      this.$store.commit('mutateStatusCakeStatus', stop);
      const msg = (!stop) ? 'On' : 'Off';
      swal('Status Cake Turned ' + msg, '', 'success');
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        message: 'User turned ' + msg + ' Status Cake.',
        level: "info"
      })
      this.opBtnLoading = false;
      if(!stop){
        console.log('Turning On Status Cake...');
        this.loadOutagesNew('Up');
        this.loadOutagesNew('Down');
      } else {
        this.destroyListeners();
      }
    },
    destroyListeners(){
      console.log('Before destroying, release all listeners...');
      if(this.upListener){
        this.upListener();
      }
      if(this.downListener){
        this.downListener();
      }
      if(this.pauseListener){
        this.pauseListener();
      }
    },
    syncStatusCake () {
      this.opBtnLoading = true;
      this.$http.post('/status_cake/sync').then(resp => {
        swal('Synchronized!', resp.data.msg, 'success');
        this.addLog({
          primaryPlan: 'Account Based Operation',
          message: 'User has synchronized Status Cake.',
          level: "info"
        })
      }).catch(e => {
        console.error(e);
        swal('Error!', 'Some thing went wrong! Please check logs', 'error');
        this.addLog({
          message: 'Some thing went wrong! Please check logs',
          level: "danger"
        })
      }).finally(() => {
        this.opBtnLoading = false;
      })
    },
    searchOutages() {
      if (this.currentOpenTab === 0) {
        this.$refs.downTable.searchQuery = this.gloablSearchQuery;
      } else {
        this.$refs.upTable.searchQuery = this.gloablSearchQuery;
      }
    },
    chnageTab(tabIndex) {
      this.currentOpenTab = tabIndex;
      if (this.currentOpenTab === 0) {
        this.$refs.downTable.searchQuery = '';
        this.gloablSearchQuery = '';
      } else if (this.currentOpenTab === 1) {
        console.log(tabIndex);
        this.$refs.upTable.searchQuery = '';
        this.gloablSearchQuery = '';
      }
    },
    toggleMute(value){
      this.$store.commit('muteNotiMutate', value);
      db.collection('users').doc(this.user.uid).update({
        muteNotiFlag: value
      });
    },
    updateIsNotificationsForUser(){
      console.log(this.isNotifications);
      if(this.isNotifications){
        this.$store.commit('notificationMutate', false);
        this.$store.dispatch('notification/resetAdminListens');
        this.$store.commit('notification/removeOutages');
        db.collection('users').doc(this.user.uid).get().then(doc => {
          const token = doc.data()['fcmToken'];
          this.$http.post('/status_cake/un_subscribe_from_topic', {
            fcmToken: token
          }).then((resp) => {
            console.log(resp.data.msg);
          });
        });
      }else{
        this.$store.commit('notificationMutate', true);
        this.$store.commit('updateAdminNotificationOnLogin', {type: 'Down', status: true}, {root:true});
        this.$store.commit('updateAdminNotificationOnLogin', {type: 'Up', status: true}, {root:true});
        this.$store.dispatch('notification/adminNotifications');
        db.collection('users').doc(this.user.uid).get().then(doc => {
          const token = doc.data()['fcmToken'];
          this.$http.post('/status_cake/subscribe_to_topic', {
            fcmToken: token
          }).then((resp) => {
            console.log(resp.data.msg);
          });
        });
      }
      db.collection('users').doc(this.user.uid).update({
        notifications: this.isNotifications
      });

    },
    addNote(){
      console.log('user', this.user)
      this.action = 'addNote';
      console.log('Adding note in: ' + this.selectedItemForView.testId);
      if(this.selectedItemForView.notes === undefined){
        this.selectedItemForView.notes = [];
      }
      this.selectedItemForView.noteAddedBy= this.user.firstName + ' ' + this.user.lastName
      this.selectedItemForView.noteAddedAt= new Date().toISOString()
      this.selectedItemForView.notes.push({
        noteDate: new Date().toISOString(),
        note: this.selectedItemForView.note,
        noteAddedBy: this.user.firstName + this.user.lastName
      });
      db.collection('status_cake_tests').doc(this.selectedItemForView.testId.toString())
        .update(this.selectedItemForView)
        .then(()=>{
          /* eslint-disable */
          $("#addNoteModal").modal("hide");
          /* eslint-enable */
          swal('Success', 'Note has been successfully added', 'success');
        }).catch(() => {
        swal('Error', 'Error in adding note!', 'error');
      }).finally(() => {
        this.selectedItemForView = {};
        this.action = null
      });
    },
    updateLiveStatus(){
      this.action = 'updateLiveStatus';
      console.log('updating live status in: ' + this.selectedItemForView.testId);
      this.selectedItemForView.events[this.selectedItemForView.events.length - 1].end = new Date().toISOString();
      this.selectedItemForView.events.push({
        start: new Date().toISOString(),
        status: this.selectedItemForView.status,
        statusCode: (this.selectedItemForView.status === 'Up') ? 200 : 0,
      });
      this.selectedItemForView.updatedAt = new Date().toISOString();
      if (this.selectedItemForView.Status === 'Down') {
        this.selectedItemForView.downCount += 1;
      }
      db.collection('status_cake_tests').doc(this.selectedItemForView.testId.toString())
        .update(this.selectedItemForView)
        .then(()=>{
          /* eslint-disable */
          $("#changeLiveStatusModal").modal("hide");
          /* eslint-enable */
          swal('Success', 'Note has been successfully added', 'success');
        }).catch(() => {
        swal('Error', 'Error in adding note!', 'error');
      }).finally(() => {
        this.selectedItemForView = {};
        this.action = null
      });
    },
    loadOutagesNew (status) {
      this.loading = false;
      let upQuery = null;
      let downQuery = null;
      if(status === 'Up') {
        this.testsOn = [];
        upQuery = db.collection('status_cake_tests')
          .where('status', '==', 'Up')
          .where('updatedAt', '>=', moment().subtract(1, 'days').toISOString())
          // .orderBy("updatedAt", "desc")
          .limit(500);
        this.upListener = upQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.testsOn.unshift(change.doc.data());
                break;
              case "modified":
              {
                const modifiedData = change.doc.data();
                let tIndex = this.testsOn.findIndex(test => test.testId === modifiedData.testId);
                this.testsOn[tIndex] = {...modifiedData}
              }
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.testsOn = this.testsOn.filter(test => test.testId !== removedData.testId);
              }
                break;
            }
          });
          console.log(this.testsOn);
          this.$refs.upTable.groupTestsInAPlan(this.testsOn);
        });
      } else {
        this.testsOff = [];
        downQuery = db.collection('status_cake_tests')
          .where('status', 'in', ['Down', 'Paused'])
          // .orderBy("updatedAt", "desc")
          .limit(500);
        this.downListener = downQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.testsOff.unshift(change.doc.data());
                break;
              case "modified":
              {
                const modifiedData = change.doc.data();
                this.testsOff = this.testsOff.filter(test => test.testId !== modifiedData.testId);
                this.testsOff.unshift(modifiedData);
              }
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.testsOff = this.testsOff.filter(test => test.testId !== removedData.testId);
              }
                break;
            }
          });
          console.log('Called Down...');
          console.log(this.testsOff);
          this.$refs.downTable.groupTestsInAPlan(this.testsOff);
        });
      }
      this.loading = true;
    },

    loadOutagesTests(status, cb) {
      this.loading = false;
      db.collection("domainsOutage")
        .where("status", "==", status)
        .get()
        .then(results => {
          let tests = this.tests;
          for (const result of results.docs) {
            const data = result.data();
            const lastDownTime = _.last(data.downTimes);

            data.id = result.id;
            data.outagesTime = '';
            data.resolutionTime = '';
            data.downTime = 0;
            data.upTime = 0;
            if(lastDownTime !== undefined){
              let time = ( moment.now() - lastDownTime.startTime) / 1000;

              data.downTime = moment.duration(time, 'seconds').format("HH:mm:ss");
              data.upTime = lastDownTime.upTime;
              data.outagesTime = moment(lastDownTime.startTime).utc().format('MMM Do, YYYY, hh:mm:ss A');

              if(data.status === 'Up'){
                data.resolutionTime = moment(lastDownTime.endTime).utc().format('MMM Do, YYYY, hh:mm:ss A');
              }
            }
            data.downTimesCount = data.downTimes.length;
            data.LastTested = moment(data.updateAt).utc().format('MMM Do, YYYY, hh:mm:ss A');
            tests.push(data);
          }
          this.tests = _.sortBy(tests, ['status']);
          this.loading = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = true;
        })
        .finally(() => {
          cb();
        });
    },
    initOutageTable(el) {
      console.log('Loading datatable');
      /* eslint-disable */
      // if($.fn.DataTable.isDataTable( `#${el}` )){
      // 	$(`#${el}`).DataTable().destroy();
      // }
      $(`#${el}`).DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        destroy: true,
        retrieve: true,
        deferRender: true,
        columnDefs: [
          { orderable: false, targets: [0,1,2] }
        ],
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search By Plan Domain For Outages",
          size: 50
        }
      });
      /* eslint-enable */
    },
    format(test) {
      let html = '';
      const downTimes = _.sortBy(test.downTimes, ['endTime'], ['desc']);
      _.forEach(downTimes, (item) => {
        let time = (item.endTime - item.startTime) / 1000;
        if (item.endTime === item.startTime){
          time = (moment.now() - item.startTime) / 1000;
        }
        // language=HTML
        html += `<tr>
						<td>Down</td>
						<td>${moment(item.startTime).format('MMM Do, YYYY, hh:mm:ss A')}</td>
						<td>${moment.duration(time, 'seconds').format("HH:mm:ss")}</td>
						<td>${test.name}</td>
						<td>${item.upTime}</td>
					</tr>`;
      });
      return `<table width="100%" cellspacing="0" border="0" style="padding-left:50px;">${html}</table>`;
    }
  },
  mounted() {
    db.collection('permissions').doc('monitor-settings').get().then(settings => {
      if(settings.exists) {
        this.selectedStatusSettings = settings.data();
      }
    });
    if(!this.isStopStatusCake) {
      this.loadOutagesNew('Up');
      this.loadOutagesNew('Down');
    } else {
      console.log('Status Cake Turned Off!');
    }
    /* eslint-disable */
    $(document).ready(function () {
      $(".datatable").DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        responsive: true,
        retrieve: true,
        order: [[0, "desc"]],
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search records"
        }
      });
    });
    const modalSelector = $('#viewEventsModal');
    modalSelector.on('show.bs.modal', function () {
      setTimeout(() => {
        $(".eventsTable").DataTable({
          pageLength:5, ordering: false,
          destroy: true, lengthChange: false,
          searching: false, deferRender: true,
          retrieve: true
        });
        $(".notesTable").DataTable({
          pageLength:5, ordering: false,
          destroy: true, lengthChange: false,
          searching: false, deferRender: true,
          retrieve: true
        });
      }, 100);
    });
    modalSelector.on('hidden.bs.modal', () => {
      this.selectedItemForView = {};
      $(".eventsTable").DataTable().destroy();
      $(".notesTable").DataTable().destroy();
    });
    /* eslint-enable */
     this.getPresetReplies()
  }
}
</script>

<style scoped>

.cursor-pointer{
  cursor: pointer !important;
}
.sc-status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}

.sc-status.down {
  background-color: #a51f1f;
}

.sc-status.up {
  background-color: #6aa529;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
.align-bottom{
  display: flex;
  align-items: center;
}
.m-t-40{
  margin-top: 40px;
}
</style>
